import { Card } from "@bp/ui-components";
import { useState } from "react";
import { type FragmentType, getFragmentData, graphql } from "../../../client/gql";
import { MODULE_CATALOG, type ModuleProduct } from "../../../utils/modules";
import { LicensedProductList } from "../../LicensedProductList/LicensedProductList";
import { ModuleEditModal } from "../modals/ModuleEditModal";

// Colocated fragment: the fields this tab (and its LicensedProductList) render.
const ProductsTab_Organization = graphql(`
  fragment ProductsTab_Organization on Organization {
    uuid
    name
    licensedApplicationsConnection {
      edges {
        properties {
          notBefore
          notAfter
          licensedModules
          tecartContractId
        }
        node {
          uuid
          clientId
        }
      }
    }
  }
`);

// clientId -> product key, for the two products whose modules are editable.
const PRODUCT_BY_CLIENT: Record<string, ModuleProduct> = {
  [MODULE_CATALOG.planung.clientId]: "planung",
  [MODULE_CATALOG.bp.clientId]: "bp",
};
const EDITABLE_CLIENT_IDS = Object.keys(PRODUCT_BY_CLIENT);

export function ProductsTab({
  org: orgRef,
}: {
  org: FragmentType<typeof ProductsTab_Organization>;
}) {
  const org = getFragmentData(ProductsTab_Organization, orgRef);
  const edges = org.licensedApplicationsConnection?.edges ?? [];
  const [editing, setEditing] = useState<ModuleProduct | null>(null);

  return (
    <Card header={{ headline: "Gebuchte Produkte" }}>
      <div
        style={{
          fontSize: "var(--font-size-s)",
          color: "var(--color-grey)",
          marginBottom: "var(--spacing-2)",
        }}
      >
        Buchung &amp; Vertrag im Orga-Portal · Zugriff im PIM
      </div>
      <LicensedProductList
        edges={edges}
        editableClientIds={EDITABLE_CLIENT_IDS}
        onEditModules={(clientId) => setEditing(PRODUCT_BY_CLIENT[clientId] ?? null)}
      />
      {editing && (
        <ModuleEditModal
          org={{ uuid: org.uuid, name: org.name }}
          product={editing}
          current={
            edges.find((e) => e.node?.clientId === MODULE_CATALOG[editing].clientId)?.properties
              ?.licensedModules ?? []
          }
          onClose={() => setEditing(null)}
          onSaved={() => setEditing(null)}
        />
      )}
    </Card>
  );
}
